export const STATIC_META_CONSTANTS = {
    CONTACTUS: "contactus",
    PRIVACYPOLICY: "privacyPolicy",
    TERMSOFPURCHASE: "termsofpurchase",
    CARS24WAY: "cars24way",
    TERMSOFUSE: "termsofuse",
    CARRER: "carrer",
    ABOUTUS: "aboutus",
    WISHLIST: "wishlist",
    THREEHUNDRED: "threeHundred",
    FINANCE: "finance",
    SITEMAP: "sidemap",
    WARRANTY: "warranty",
    TERMSOFSALE: "termsofsale",
    TRADEIN: "trade-in"
};

export default {
    [STATIC_META_CONSTANTS.CONTACTUS]: {
        "title": "CARS24 Australia | Contact Us",
        "description": ""
    },
    [STATIC_META_CONSTANTS.PRIVACYPOLICY]: {
        "title": "CARS24 | Privacy Policy"
    },
    [STATIC_META_CONSTANTS.TRADEIN]: {
        "title": "CARS24 | Trade-in your car",
        "description": ""
    },
    [STATIC_META_CONSTANTS.TERMSOFPURCHASE]: {
        "title": "CARS24 | Terms of Purchase",
        "description": ""
    },
    [STATIC_META_CONSTANTS.CARS24WAY]: {
        "title": "CARS24 | The CARS24 way",
        "description": "Buy a used car 100% online the CARS24 way. Quality assured used cars with easy finance, 7-day return & 100% money back guarantee."
    },
    [STATIC_META_CONSTANTS.TERMSOFUSE]: {
        "title": "CARS24 | Terms of Use",
        "description": ""
    },
    [STATIC_META_CONSTANTS.CARRER]: {
        "title": "CARS24 | Career",
        url: "/career"
    },
    [STATIC_META_CONSTANTS.ABOUTUS]: {
        "title": "CARS24 | About Us",
        "description": "We’re here to transform the way that Australia buys and sells used cars, making it as easy and convenient as any other online purchase."
    },
    [STATIC_META_CONSTANTS.WISHLIST]: {
        "title": "CARS24 - Buy quality used cars 100% online in Australia"
    },
    [STATIC_META_CONSTANTS.THREEHUNDRED]: {
        "title": "CARS24 - Buy quality used cars 100% online in Australia"
    },
    [STATIC_META_CONSTANTS.FINANCE]: {
        "title": "CARS24 | Finance",
        "metaTitle": "Used Car Loan & Finance Australia: Apply Online Now",
        "description": "Looking for hassle-free used car loans and finance in Australia? Apply online now at CARS24 to get quick approval and competitive rates. Drive home your dream car with ease!"
    },
    [STATIC_META_CONSTANTS.SITEMAP]: {
        "title": "CARS24 | Sitemap"
    },
    [STATIC_META_CONSTANTS.WARRANTY]: {
        "title": "CARS24 | Warranty"
    },
    [STATIC_META_CONSTANTS.TERMSOFSALE]: {
        "title": "CARS24 | Terms of Sale"
    }
};
